import React, { useEffect, useState } from 'react';
import { Container, Card, Row, Col, ListGroup, Badge, Image } from 'react-bootstrap';
import api from '../utils/api';

const GhinStats = () => {
  const [stats, setStats] = useState({ 
    handicap: '', 
    rounds: 0, 
    lowRound: 0, 
    lastPlayed: '',
    recentRounds: []
  });
  const [show, setShow] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchGhin = async () => {
      try {
        const { data } = await api.get('/ghin/data');
        if (data.show) {
          setStats({ 
            handicap: data.handicap, 
            rounds: data.rounds,
            lowRound: data.lowRound,
            lastPlayed: data.lastPlayed,
            recentRounds: data.recentRounds || []
          });
          setShow(true);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchGhin();
  }, []);

  if (!show) return null;

  return (
    <section className="page-section bg-light-custom" id="ghin">
      <Container className="px-4 px-lg-5">
        <h2 className="text-center mt-0">Golf Stats</h2>
        <hr className="divider my-4 bg-primary opacity-100 mx-auto" style={{ width: '100px', height: '3px' }} />
        
        <Row className="justify-content-center g-4">
          {/* Column 1: Handicap Index */}
          <Col md={4}>
            <Card className="text-center shadow-sm border-0 h-100">
              <Card.Body className="d-flex flex-column justify-content-center p-4">
                <div className="mb-3">
                  <Image 
                    src={`${API_URL}/uploads/ghin-logo.png`} 
                    alt="GHIN Logo" 
                    style={{ maxWidth: '120px', height: 'auto' }} 
                  />
                </div>
                <div className="display-1 fw-bold text-primary mb-2">{stats.handicap}</div>
                <div className="text-muted">Handicap Index®</div>
              </Card.Body>
            </Card>
          </Col>

          {/* Column 2: Season Stats */}
          <Col md={4}>
            <Card className="shadow-sm border-0 h-100">
              <Card.Body className="p-4 d-flex flex-column justify-content-center">
                <h3 className="h5 text-center text-muted mb-4 text-uppercase tracking-wider">Season Stats</h3>
                
                <div className="d-flex justify-content-between align-items-center mb-3 px-3">
                  <span className="text-muted">Rounds YTD</span>
                  <span className="h4 mb-0 fw-bold">{stats.rounds}</span>
                </div>
                <hr className="my-2 opacity-25" />
                
                <div className="d-flex justify-content-between align-items-center mb-3 px-3">
                  <span className="text-muted">Low Round</span>
                  <span className="h4 mb-0 fw-bold text-success">{stats.lowRound > 0 ? stats.lowRound : '-'}</span>
                </div>
                <hr className="my-2 opacity-25" />

                <div className="d-flex justify-content-between align-items-center px-3">
                  <span className="text-muted">Last Played</span>
                  <span className="fw-bold">{stats.lastPlayed}</span>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Column 3: Recent Rounds */}
          <Col md={4}>
            <Card className="shadow-sm border-0 h-100">
              <Card.Body className="p-4">
                <h3 className="h5 text-center text-muted mb-4 text-uppercase tracking-wider">Recent Rounds</h3>
                <ListGroup variant="flush">
                  {stats.recentRounds.map((round, idx) => (
                    <ListGroup.Item key={idx} className="d-flex justify-content-between align-items-center px-0 border-bottom">
                      <span className="text-muted small">{round.date}</span>
                      <div className="d-flex align-items-center">
                        <Badge bg="light" text="dark" className="me-2 border fw-normal">Diff: {round.differential}</Badge>
                        <span className="fw-bold h6 mb-0">{round.score}</span>
                      </div>
                    </ListGroup.Item>
                  ))}
                  {stats.recentRounds.length === 0 && (
                    <div className="text-center text-muted mt-3">No recent rounds found.</div>
                  )}
                </ListGroup>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default GhinStats;
